import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useRetainersDashboardOverviewBudget = () => {
    const { getDataAsync } = useApi();

    const getBudgetSummaryApiCall = useCallback(
        async ({ endpointSuffix, retainerId, startDate, endDate }) => {
            const response = await getDataAsync(
                "retainersDashboardBudgetSummary",
                {
                    urlParams: [
                        { name: "$endpointSuffix", value: endpointSuffix },
                        { name: "$retainerId", value: retainerId },
                        { name: "$startDate", value: startDate },
                        { name: "$endDate", value: endDate },
                    ],
                }
            );

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useBudgetSummary = (dataObj) =>
            useQuery(
                [`budgetSummary${dataObj.endpointSuffix}`, dataObj],
                () => getBudgetSummaryApiCall(dataObj)
            );
        return {
            useBudgetSummary,
        };
    }, [getBudgetSummaryApiCall]);
};

export default useRetainersDashboardOverviewBudget;
